import { BCMSCurrency, BCMSDate, BCMSRecord,BCMSValidate, Branding, BrandingStyle, Link, useBCMSContext, useModel, useStateManager, useWorkflow } from "bcms-react";
import { getDefaultStopPayment } from "components/workflows/StopPaymentsWorkflow";
import StopPayment from "components/workflows/StopPaymentsWorkflow/classes/StopPayment";
import Classes from "model";
import React from "react";

import { CenterContentContainer, ContentHeaderView, FormRowView, LayoutContainer, LeftColumnContainer, PageContainer, PageContentView, PageLayoutContainer, RightColumnContainer } from "components/shared";
import { InfoBanner } from "components/shared/views/ConfirmBannerView";
import { PrimaryButton } from "components/ui";

import "./mobile.css";
import "./styles.css";
import CustomContentHeaderWidget from "components/shared/views/CustomContentHeaderWidget";

/**
 * @function StopPaymentConfirmPage
 * @return {React.Component}
 * @exported true
 * @description The main component for StopPaymentConfirmPage
 */
export default function StopPaymentConfirmPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const { branding } = useModel();
    const { options } = branding;
    const data = { ...getDefaultPageData(options), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const { prevStep } = useWorkflow() ?? {};

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onBack: evt => prevStep(getDefaultStopPayment(globalController))
    });

    return (
        <PageContainer className="stop-payment-confirm-page" state={{ data, ui }} controller={controller}>
            <StopPaymentConfirmContent />
        </PageContainer>
    );
}

export const getDefaultPageData = brandingOptions => {
    let options = brandingOptions ?? {};
    let stopPaymentFeeAmount = options.stop_payment_fee_amount_abi22;
    stopPaymentFeeAmount = stopPaymentFeeAmount === "undefined" ? "X.XX" : stopPaymentFeeAmount;
    stopPaymentFeeAmount = BCMSValidate.isNumber(stopPaymentFeeAmount)
    ? BCMSCurrency.init(stopPaymentFeeAmount).format()
    : stopPaymentFeeAmount;

    return {
        payment: StopPayment.init({}),
        stopPaymentFeeAmount: stopPaymentFeeAmount
    }
};
export const getDefaultPageUI = () => ({});

function StopPaymentConfirmContent(props) {
    const { data, onBack } = useStateManager();
    const stopPayment = data.payment;
    const { branding } = useModel();

    let checkNumbers = stopPayment.paymentType === "Single Check" ? stopPayment.checkNumber : stopPayment.startCheckNumber + "-" + stopPayment.endCheckNumber;
    
    if(stopPayment.paymentType === "Single Check" && stopPayment.checkNumber === "") {
        checkNumbers = "";
    }
    
    let amount = stopPayment.amount instanceof BCMSCurrency ? stopPayment.amount.format() : BCMSCurrency.init(stopPayment.amount).format();
    amount = stopPayment.amount === "" ? "" : amount;
    const feeMessage = `A fee of ${ data.stopPaymentFeeAmount } applies for stop payment.`;
    const promoText = branding.options.stop_payment_promo_abi22;

    return (
        <PageContentView>
            <InfoBanner text={"A stop payment for check " + checkNumbers + " has successfully been placed on " + stopPayment.account.nickname} />
            {/* Banner to add */}
            {promoText && <CustomContentHeaderWidget content={promoText} />}
            <Branding id="stop_payment_fee_abi22" value="true" default="false">
                <BrandingStyle style={{ "color" : "stop_payment_fee_text_abi22" }} className="stop-payment-fee" element={ <p>{ feeMessage }</p> } />          
            </Branding>
            <CenterContentContainer>
                <ContentHeaderView text="Stop Payment" />
                <Link to="/stopPaymentHistory" className="stop-payment-history-link" dataPoint="Stop_Payment_History">Stop Payment History</Link>

                <div className="flex-container flex-horizontal details-container">
                    <div className="flex-container flex-vertical set-width left-detail-container">
                        <b className="text-right detail-label">Tracking ID:</b>
                        <b className="text-right detail-label">Account:</b>
                        <b className="text-right detail-label">Amount:</b>
                        <b className="text-right detail-label">Check(s):</b>
                        <b className="text-right detail-label">Scheduled Date & Time:</b>
                    </div>
                    <div className="flex-container flex-vertical flex-width right-detail-container">
                        <p className="detail-text">1111</p>
                        <p className="detail-text">{stopPayment.account.number}</p>
                        <p className="detail-text">{amount}</p>
                        <p className="detail-text">{checkNumbers}</p>
                        <p className="detail-text">{BCMSDate.init().format("m/d/Y h:m:s")} AM</p>
                    </div>
                </div>
                <FormRowView>
                    <PrimaryButton text="Back" onClick={onBack} />
                </FormRowView>
            </CenterContentContainer>
        </PageContentView>
    );
}